import React, { useContext, useState } from "react";
import { ProjectContext } from "../../ProjectContext";
import { Link } from "react-router-dom";
import Dropdown from "../Dropdown";
import DropdownMobile from "../DropdownMobile";

export default function Header() {
  const { account, connectMetamask } = useContext(ProjectContext);

  const [show, setShow] = useState(false);

  return (
    <div>
      <header className="tp-header-height">
        {/* header top area start */}
        <div
          id="header-sticky"
          className="tp-header-area tp-header-mob-space tp-transparent pl-60 pr-60 z-index-9"
        >
          <div className="container">
            <div className="row align-items-center justify-content-sm-between">
              <div className="col-xl-3 col-lg-2 col-6">
                <div className="tp-header-logo">
                  <a className="logo-2 dk" href="/">
                    <img
                      src="assets/img/one/kryptogram_white_logo.svg"
                      className="img-fluid"
                      alt=""
                    />
                  </a>
                  {/* <a className="d-md-none d-block logo-2" href="/">
                    <img src="favicon.png" alt="" height={20} width={20} />
                  </a> */}
                </div>
              </div>
              <div className="col-xl-6 col-lg-8   d-none d-xl-block">
                <div className="tp-header-menu header-main-menu text-center">
                  <nav className="tp-main-menu-content">
                    <ul>
                      <li className="">
                        <a href="/">
                          <h6>Home</h6>
                        </a>
                      </li>
                      <li className="">
                        <a href="/about-us">
                          <h6>About Us</h6>
                        </a>
                      </li>
                      <li className="">
                        <a href="/faq">
                          <h6>FAQ</h6>
                        </a>
                      </li>
                      <li className="">
                        <a href="/buy-nft">
                          <h6>Buy NFT</h6>
                        </a>
                      </li>
                      {/* <li className="">
                        <a href="/contact">Contact</a>
                      </li> */}
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-xl-3 col-lg-2 col-5 d-flex justify-content-end align-items-center gap-3 ">
                <div className="tp-header-bar text-end ">
                  {account ? (
                    <>
                      <div className=" d-none d-md-block ">
                        <Dropdown />
                      </div>
                      <div className="d-block d-md-none px-3  ">
                        <DropdownMobile />
                      </div>
                    </>
                  ) : (
                    <>
                      <button
                        className="tp-btn-black-2 tp_fade_bottom d-none d-md-block "
                        onClick={connectMetamask}
                      >
                        Connect Wallet
                      </button>
                      <button
                        className="tp-btn-black-2 tp_fade_bottom d-block d-md-none px-3  "
                        onClick={connectMetamask}
                      >
                        <i class="fa-solid fa-wallet"></i>
                      </button>
                    </>
                  )}
                </div>
                <div className="tp-header-bar text-end d-block d-xl-none">
                  <button
                    className="tp-offcanvas-open-btn"
                    onClick={() => setShow(true)}
                  >
                    <span />
                    <span />
                  </button>
                </div>
              </div>
              {/* <div className="col-xl-2 col-lg col-5 d-xl-none"></div> */}
            </div>
          </div>
        </div>
        {/* header top area end */}
      </header>

      <div
        className={`tp-offcanvas-area ${show ? "opened" : "tp-offcanvas-area"}`}
      >
        <div className="tp-offcanvas-wrapper">
          <div className="tp-offcanvas-top d-flex align-items-center justify-content-between">
            <div className="tp-offcanvas-logo">
              <a href="#">
                <img
                  className="logo-1"
                  style={{ width: "250px" }}
                  src="assets/img/one/kryptogram_black_logo.svg"
                  alt=""
                />
                <img
                  className="logo-2"
                  style={{ width: "250px" }}
                  src="assets/img/one/kryptogram_white_logo.svg"
                  alt=""
                />
              </a>
            </div>
            <div className="tp-offcanvas-close">
              <button
                className="tp-offcanvas-close-btn"
                onClick={() => setShow((prev) => !prev)}
              >
                <svg
                  width={37}
                  height={38}
                  viewBox="0 0 37 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.19141 9.80762L27.5762 28.1924"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.19141 28.1924L27.5762 9.80761"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="tp-offcanvas-main">
            <div className="tp-main-menu-mobile d-xl-none">
              <nav className="tp-main-menu-content">
                <ul>
                  <li className="has-dropdown has-homemenu">
                    <a href="/">
                      <h6>Home</h6>
                    </a>
                  </li>
                  <li className="has-dropdown">
                    <a href="/about-us">
                      <h6>About Us</h6>
                    </a>
                  </li>
                  <li className="has-dropdown has-homemenu">
                    <a href="/faq">
                      <h6>FAQ</h6>
                    </a>
                  </li>
                  <li className="has-dropdown">
                    <a href="/buy-nft">
                      <h6>Buy NFT</h6>
                    </a>
                  </li>
                  {/* <li className="has-dropdown">
                    <a href="#">
                      Contact
                     
                    </a>
                  </li> */}
                </ul>
              </nav>

              <div className="tp-header-bar">
                {account ? (
                  <Link className="tp-btn-black-2 tp_fade_bottom" to="/account">
                    Dashboard
                  </Link>
                ) : (
                  <button
                    className="tp-btn-black-2 tp_fade_bottom"
                    onClick={connectMetamask}
                  >
                    Connect Wallet
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
